import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DayOfRaceDate } from '@cds/betting-offer/domain-specific/horse-racing';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { HooksWireup } from '@frontend/sports/common/core/utils/hooks';
import { CdsPushStoreService } from '@frontend/sports/content-distribution/feature';

import { BaseDayOfRaceComponent } from '../tournaments/base-day-of-race.component';

@HooksWireup()
@Component({
    selector: 'ms-horses-tomorrow',
    templateUrl: 'horses-tomorrow.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class HorsesTomorrowComponent extends BaseDayOfRaceComponent {
    readonly tomorrow: DayOfRaceDate = DayOfRaceDate.Tomorrow;

    constructor(
        public sitecore: Sitecore,
        route: ActivatedRoute,
        changeDetector: ChangeDetectorRef,
        pushService: CdsPushStoreService,
    ) {
        super(route, changeDetector, pushService);
    }
}
